import React from 'react';
import ReactMarkdown from 'react-markdown';
import { parseTaskBlocks, Task } from '../../../utils/taskParser';
import { TaskDisplay } from './TaskDisplay';

interface TaskContentProps {
  content: string;
  className?: string;
}

/**
 * Component that parses content for task blocks and renders them appropriately
 * Regular text is rendered as markdown, task blocks are rendered with TaskDisplay
 */
export const TaskContent: React.FC<TaskContentProps> = ({ content, className }) => {
  const parsedContent = React.useMemo(() => parseTaskBlocks(content), [content]);

  if (parsedContent.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {parsedContent.map((block, index) => {
        if (block.type === 'tasks') {
          return (
            <TaskDisplay
              key={`tasks-${index}`}
              tasks={block.content as Task[]}
              title={block.title}
              className="my-3"
            />
          );
        } else {
          // Render text content as markdown
          return (
            <div key={`text-${index}`} className="prose prose-sm max-w-none dark:prose-invert">
              <ReactMarkdown>{block.content as string}</ReactMarkdown>
            </div>
          );
        }
      })}
    </div>
  );
};